import React from "react";
import { DivisorPeB } from "../../divisor";

export const AraucariaEstacionamento: React.FC = () => {
    return (
        <>
            <DivisorPeB />
            <br />
            <div className="text-center">
                <a
                    href="http://geo.araucaria.pr.gov.br/webgeo/geo_mapa/view/Lei%20Complementar%2026-2020%20-%20Recortada.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-center"
                >
                    VAGAS PARA ESTACIONAMENTO - Anexo VII da Lei Complementar n°
                    26/2020
                </a>
            </div>
            <br />
            <DivisorPeB />
        </>
    );
};
